import React, { ReactNode } from 'react';

type ContextProviderProps = {
  children: ReactNode;
};

type WrapWithProvider<T> = (
  Component: React.MemoExoticComponent<any>
) => React.FC<T>;

function withContextProvider<T>(
  Provider: React.ComponentType<ContextProviderProps>
): WrapWithProvider<T> {
  return (Component: React.MemoExoticComponent<any>) => {
    const WrappedComponent: React.FC<T> = (props) => (
      <Provider>
        <Component {...props} />
      </Provider>
    );
    return WrappedComponent;
  };
}

export default withContextProvider;
